export const CCTV = {
  CCTVLIST: 'cctv_list',
};
